var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.attentions")
            }
          }
        },
        [_vm._v("Volver a Atenciones")]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticStyle: { "padding-inline-start": "0px" } },
        _vm._l(_vm.groupOfAttentions, function(studentAttention) {
          return _c(
            "li",
            { key: studentAttention.id },
            [
              _c(
                "block",
                {
                  staticStyle: { "padding-bottom": "60px", margin: "10px 0" },
                  attrs: { "bordered-header": true }
                },
                [
                  _c("template", { slot: "header" }, [
                    _vm._v(_vm._s(_vm.attentionTitle(studentAttention)))
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "subheader" }, [
                    _vm._v(_vm._s(_vm.attentionStatus(studentAttention)))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "meta-list" }, [
                    _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Registrado por:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(_vm._s(studentAttention.creator.name))
                      ]),
                      _vm._v(
                        "\n            (" +
                          _vm._s(
                            _vm._f("formatStandardDate")(
                              studentAttention.createdAt
                            )
                          ) +
                          ")\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Responsable asignado:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(_vm._s(studentAttention.responsible.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Fecha límite asignada:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatStandardDate")(studentAttention.dueBy)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    studentAttention.participationOf &&
                    studentAttention.participationOf.comment.comment
                      ? _c("div", { staticClass: "meta-item" }, [
                          _c(
                            "span",
                            { staticClass: "meta-name has-text-weight-bold" },
                            [_vm._v("Resultado:")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v(
                              _vm._s(
                                studentAttention.participationOf.comment.comment
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    studentAttention.status !== "FAILED" &&
                    studentAttention.participationOf &&
                    studentAttention.participationOf["evaluation"]
                      ? _c("div", { staticClass: "meta-item" }, [
                          _c(
                            "span",
                            { staticClass: "meta-name has-text-weight-bold" },
                            [_vm._v("Evaluación:")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "meta-value" }, [
                            _c("button", { staticClass: "emotion" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.evaluationIconScore[
                                      studentAttention.participationOf[
                                        "evaluation"
                                      ]
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Fecha de cierre:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("formatStandardDate")(
                                studentAttention.performedAt
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Responsable de cierre:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(_vm._s(_vm.finishedByUser(studentAttention)))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [_c("i")]),
                  _vm._v(" "),
                  !studentAttention.isDone
                    ? _c("div", { staticClass: "actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            on: { click: _vm.finishAttention }
                          },
                          [_vm._v("Finalizar")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }